import { FirmwareType } from '../support/pages/firmware-page/FirmwarePage'

import api from './api'

export default (query?: Query): Promise<Product[]> => api.get({ path: '/products', query })

export enum ProductVariant {
    Chargepoint = 'Chargepoint',
    ChargingCable = 'ChargingCable',
    MeasurementDevice = 'MeasurementDevice',
}

export type Query = {
    productVariant?: ProductVariant
}

export interface Product {
    // not sure about any of those types
    id: number
    name: string
    description: string
    serialNumberSuffix: 'G'
    manufacturer: string
    productVariant: ProductVariant
    hardwareVersion: string | null
    firmwareTypes: Array<FirmwareType>
}
